import * as Sentry from "@sentry/react";

/**
 * Reports a user code-library Firestore failure to Sentry with stable grouping
 * and enough context to triage save vs delete and component/code identity.
 */
export const captureCodeLibFirestoreError = (
    error,
    { operation, uid, componentType, codeRef, user: { email, uid: userUid, name } = {} } = {}
) => {
    const resolvedUid = uid || userUid;

    Sentry.withScope((scope) => {
        const sentryError =
            error instanceof Error ? error : new Error(error ? String(error) : "Code library Firestore error");

        scope.setFingerprint(["code-lib-firestore-error", operation || "unknown"]);
        scope.setTag("code_lib_firestore_error", true);
        scope.setTag("code_lib_operation", operation);
        scope.setTag("component_type", componentType);
        if (resolvedUid) {
            scope.setTag("uid", resolvedUid);
        }
        scope.setExtras({
            uid: resolvedUid,
            operation,
            componentType,
            codeRef,
            firestoreCode: error?.code,
            firestoreMessage: error?.message,
        });
        scope.setTransactionName("Code library Firestore error");
        scope.setLevel("warning");
        scope.setUser({ email, uid: resolvedUid, name });

        scope.captureException(sentryError);
    });
};
